// Country Road Fashions — the Fit step (Shiva, 2026-10-01).
//
// The three avenues are radio rows; CSS :has() shows the chosen panel. This
// script does the part CSS cannot: it disables every field of the avenues not
// chosen, so only one set of attributes reaches the cart and `required` is
// asked of the right fields. The body/garment choice does the same for the
// measurement fields. Without it, the page still submits what was typed.
//
// The size grid (docs/SIZE-GRID.md, 2026-10-10). The third avenue's rows
// (collar × fit, the finished shirt's ten measurements) arrive in a JSON
// island from the crf_size_row metaobject. This finds the row for the chosen
// collar and fit, applies each tweak select's step (quarter inches, read from
// the option's data-in; the words staff wrote are what the order carries), shows
// the finished shirt, and writes its numbers as hidden `Fit · …` attributes
// in the guide's ten names, plus `Fit · check`: the height/weight estimate
// against the size, starting with the flag word when a tailor should look
// (the thresholds and the words come from the section's settings).
(function () {
  function init(root) {
    root.querySelectorAll('[data-crf-fit]').forEach(function (fit) {
      if (fit.dataset.crfFitReady) return;
      fit.dataset.crfFitReady = '1';
      var avenues = fit.querySelectorAll('[data-crf-fit-avenue]');
      var panels = fit.querySelectorAll('[data-crf-fit-panel]');
      var ofs = fit.querySelectorAll('[data-crf-fit-of]');
      var grid = gridInit(fit);

      function fields(scope) { return scope.querySelectorAll('input, select, textarea'); }
      function setOn(scope, on) {
        scope.classList.toggle('is-active', on);
        scope.hidden = !on;
        fields(scope).forEach(function (f) { f.disabled = !on; });
      }
      function sync() {
        var chosen = '1';
        avenues.forEach(function (r) { if (r.checked) chosen = r.dataset.crfFitAvenue; });
        panels.forEach(function (p) { setOn(p, p.dataset.crfFitPanel === chosen); });
        var of = 'body';
        ofs.forEach(function (r) { if (r.checked) of = r.dataset.crfFitOf; });
        fit.querySelectorAll('[data-crf-fit-kind]').forEach(function (m) {
          var k = m.dataset.crfFitKind;
          var on = k === 'both' || k === of;
          m.hidden = !on;
          fields(m).forEach(function (f) { f.disabled = !on || m.closest('[data-crf-fit-panel]').hidden; });
        });
        if (grid) grid.update();
      }
      // On submit, every attribute of the avenues not chosen is sent empty,
      // which removes it from the cart. Otherwise a customer who changed
      // their mind would reach the order with both sets of answers.
      var form = fit.querySelector('form');
      if (form) form.addEventListener('submit', function () {
        form.querySelectorAll('[data-crf-fit-clear]').forEach(function (h) { h.remove(); });
        // form.elements, not the form's descendants, so a field tied to the form
        // by its `form` attribute from outside it is counted too.
        var all = Array.prototype.filter.call(form.elements, function (f) { return /^(INPUT|SELECT|TEXTAREA)$/.test(f.tagName); });
        var live = {};
        all.forEach(function (f) { if (!f.disabled && f.name) live[f.name] = true; });
        var cleared = {};
        all.forEach(function (f) {
          if (!f.disabled || !f.name || live[f.name] || cleared[f.name]) return;
          if (f.name.indexOf('attributes[') !== 0) return;
          cleared[f.name] = true;
          var h = document.createElement('input');
          h.type = 'hidden'; h.name = f.name; h.value = ''; h.setAttribute('data-crf-fit-clear', '');
          form.appendChild(h);
        });
      });
      // The fit on record (2026-10-06). `Fit · source` travels with the order
      // only while the record is used untouched: opening "Change it" drops
      // it. And if the folded, prefilled form fails validation (a measurement
      // added since the record was written), the fold opens so the browser
      // can point at the field instead of refusing silently.
      // While the fold is shut the record travels as its own hidden fields
      // and every field inside the fold is disabled (2026-10-14), so a record
      // written before a measurement became required still goes through.
      // Opening Change it swaps them: the fold's fields come back, prefilled,
      // and the record's hidden fields and `Fit · source` step aside.
      var change = fit.querySelector('[data-crf-fit-change]');
      var source = fit.querySelector('[data-crf-fit-source]');
      var recFields = fit.querySelectorAll('[data-crf-fit-recfield]');
      function syncRecord() {
        if (!change) return;
        var folded = !change.open && (recFields.length > 0 || !!source);
        if (source) source.disabled = !folded;
        recFields.forEach(function (f) { f.disabled = !folded; });
        // Shut: everything in the fold off. Open: everything back on first,
        // then sync() turns off the avenues not chosen as usual.
        fields(change).forEach(function (f) { f.disabled = folded; });
        if (!folded) sync();
      }
      if (change) change.addEventListener('toggle', syncRecord);
      // Use this fit means the record, whatever the fold is doing: shut it
      // and swap the fields before the browser validates and submits.
      var use = fit.querySelector('[data-crf-fit-use]');
      if (use && change) use.addEventListener('click', function () {
        if (change.open) { change.open = false; syncRecord(); }
      });
      // The browser runs validation before any submit event, so the fold is
      // opened from the controls' own `invalid` events (capture: they do not
      // bubble), which fire before the browser focuses the first bad field.
      if (form && change) form.addEventListener('invalid', function () {
        if (!change.open) change.open = true;
      }, true);
      avenues.forEach(function (r) { r.addEventListener('change', sync); });
      ofs.forEach(function (r) { r.addEventListener('change', sync); });

      // The unit beside every number follows the cm / in radios.
      var units = fit.querySelectorAll('input[name$="[Fit · unit]"]');
      function syncUnit() {
        var u = 'cm';
        units.forEach(function (r) { if (r.checked) u = r.value; });
        fit.querySelectorAll('[data-crf-fit-unit]').forEach(function (s) { s.textContent = u; });
        fit.querySelectorAll('[data-crf-fit-chips]').forEach(function (c) { c.classList.toggle('is-in', u === 'in'); });
        if (grid) grid.update();
      }
      units.forEach(function (r) { r.addEventListener('change', syncUnit); });
      syncUnit();

      // The measuring figures (2026-10-10): the tape is drawn on once, when a card
      // comes on screen, and stays; it draws again from the start when focus enters
      // the card (not on every click inside it). Off with the section's switch or
      // reduced motion; the tape then sits fully drawn. It looped until 2026-10-14.
      var cards = fit.querySelectorAll('[data-crf-fit-measure]');
      var play = fit.dataset.crfFitPlay !== 'false'
        && 'IntersectionObserver' in window
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (play && cards.length) {
        fit.classList.add('crf-mf-anim');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-live');
            io.unobserve(e.target); // drawn once; scrolling past never pauses or restarts it
          });
        }, { threshold: 0.4 });
        cards.forEach(function (c) {
          io.observe(c);
          c.addEventListener('focusin', function (ev) {
            if (ev.relatedTarget && c.contains(ev.relatedTarget)) return; // focus moved within the card
            c.classList.add('is-live');
            c.querySelectorAll('.crf-mf__tape, .crf-mf__label, .crf-mf__mark').forEach(function (el) {
              el.style.animation = 'none';
              el.getBoundingClientRect(); // SVG elements have no offsetWidth; this forces the reflow that restarts the draw
              el.style.animation = '';
            });
          });
        });
      }

      // The i on the pay-first choice (2026-10-21): a note on hover or tap.
      var info = fit.querySelector('[data-crf-fit-info]');
      var tip = info && document.getElementById(info.getAttribute('aria-controls'));
      if (info && tip) {
        var setTip = function (on) { tip.hidden = !on; info.setAttribute('aria-expanded', on ? 'true' : 'false'); };
        info.addEventListener('click', function () { setTip(true); }); // hover or tap opens it; leaving, blur or Escape closes it
        info.addEventListener('mouseenter', function () { setTip(true); });
        info.addEventListener('mouseleave', function () { if (document.activeElement !== info) setTip(false); });
        info.addEventListener('blur', function () { setTip(false); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTip(false); });
      }

      // The send page (after paying, 2026-10-21): the confirmation email's link
      // carries the order number as ?order=, so the customer need not type it.
      var order = fit.querySelector('[data-crf-fit-order]');
      if (order && !order.value) {
        var n = new URLSearchParams(location.search).get('order');
        if (n) order.value = n;
      }

      // The showroom name is required only once the script runs, for the same reason as the collar chips.
      fit.querySelectorAll('[data-crf-fit-name]').forEach(function (el) { el.required = true; });
      fit.classList.add('is-scripted');
      sync();
      syncRecord();
    });
  }

  function gridInit(fit) {
    var island = fit.querySelector('[data-crf-fit-grid]');
    if (!island) return null;
    var data;
    try { data = JSON.parse(island.textContent); } catch (e) { return null; }
    var rows = data.rows || [], check = data.check || {};
    var panel = island.closest('[data-crf-fit-panel]');
    var collars = panel.querySelectorAll('[data-crf-fit-collar]');
    var fits = panel.querySelectorAll('[data-crf-fit-fit]');
    var tweaks = panel.querySelectorAll('[data-crf-fit-tweak]');
    var letter = panel.querySelector('[data-crf-fit-letter]');
    var height = panel.querySelector('[data-crf-fit-height]');
    var weight = panel.querySelector('[data-crf-fit-weight]');
    var notes = panel.querySelector('textarea');
    var shirt = panel.querySelector('[data-crf-fit-shirt]');
    var outs = panel.querySelectorAll('[data-crf-fit-out]');
    var checkOut = panel.querySelector('[data-crf-fit-check]');
    panel.querySelectorAll('[data-crf-fit-scripted]').forEach(function (el) { el.hidden = false; });
    // A collar must be picked, but only when this avenue is the one chosen: with scripts
    // off the panel's fields stay enabled while hidden, and a required radio there would
    // block the form from avenues 1 and 2 without a word (2026-10-14). The script disables
    // the fields of the other avenues, so here the requirement is safe.
    collars.forEach(function (r) { r.required = true; });

    function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }
    function fmt(n) { return String(Math.round(n * 10) / 10); }
    // Inches as the house writes them: quarters, always (Shiva, 2026-10-14).
    var FR4 = ['', '\u00BC', '\u00BD', '\u00BE'];
    function frac(x) { var n = Math.round(x * 4), w = Math.floor(n / 4), f = FR4[n - w * 4]; return (w || !f ? w : '') + f; }
    function inches() { var r = fit.querySelector('input[name$="[Fit \u00B7 unit]"][value="in"]'); return !!(r && r.checked); }
    function shown(cm) { return inches() ? frac(cm / 2.54) : fmt(cm); }
    // The option's value keeps the inches the house works in; the cm reading is for the customer who chose cm.
    function relabel(sel) {
      var useIn = inches();
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (!o.value) continue;
        var inch = Math.abs(num(o.getAttribute('data-in')) || 0);
        o.textContent = useIn || !inch ? o.value : o.value.replace(/\(([+\u2212-])[^)]*in\)/, function (_, sign) { return '(' + sign + fmt(inch * 2.54) + ' cm)'; });
      }
    }
    function picked(list) { var v = null; list.forEach(function (r) { if (r.checked) v = r; }); return v; }
    function findRow(collar, fitKey) {
      for (var i = 0; i < rows.length; i++) {
        if (String(rows[i].collar) === String(collar) && rows[i].fit === fitKey) return rows[i];
      }
      return null;
    }
    // "Longer sleeves, more (+1 in)" → +2.54: the option's data-in, in cm for the row's numbers.
    function delta(sel) {
      var o = sel.options[sel.selectedIndex];
      var inch = o ? num(o.getAttribute('data-in')) : null;
      return inch ? inch * 2.54 : 0;
    }
    function atLimit(sel) {
      if (!sel.value) return false;
      var first = sel.options[0], last = sel.options[sel.options.length - 1];
      return sel.selectedIndex === sel.options.length - 1 && last.value !== '' ||
             sel.selectedIndex === 0 && first.value !== '';
    }

    // The estimate (ANSUR II, own fit, age folded in at 28; SIZE-GRID.md §5),
    // then the rule: outside any tolerance, or a tweak at its ceiling, or a
    // letter size, or a note, and the order gets a look before cutting.
    function checkText(row, collar, vals, limit) {
      var H = height ? num(height.value) : null, W = weight ? num(weight.value) : null;
      var c = num(collar), reasons = [], fine = [];
      if (H && W && c != null) {
        var chestEst = 101.3 - 0.269 * H + 0.602 * W + (check.chestShift || 0);
        var neckEst = 40.2 - 0.079 * H + 0.157 * W;
        var sleeveEst = -4.3 + 0.363 * H + (check.sleeveAdd == null ? 5 : check.sleeveAdd); // shoulder point to wrist, plus the house's sleeve allowance
        var chestFor = 88 + 4 * (c - 37);
        var chestLine = 'chest estimate ' + Math.round(chestEst) + ' for collar ' + c + ', expected about ' + chestFor;
        if (Math.abs(chestEst - chestFor) > (check.chestTol || 5)) reasons.push(chestLine); else fine.push(chestLine);
        if (Math.abs(neckEst - c) > (check.neckTol || 2)) reasons.push('neck estimate ' + fmt(neckEst) + ' for collar ' + c);
        if (vals.sleeve != null && Math.abs(sleeveEst - vals.sleeve) > (check.sleeveTol || 4)) {
          reasons.push('sleeve estimate ' + Math.round(sleeveEst) + ', shirt sleeve ' + fmt(vals.sleeve));
        }
      } else {
        reasons.push('no height and weight');
      }
      if (limit) reasons.push('a tweak at its limit');
      if (letter && letter.value) reasons.push('size given as ' + letter.value + ', collar assumed');
      if (notes && notes.value.trim()) reasons.push('a note written');
      if (reasons.length) return (check.look || 'Look') + ': ' + reasons.join('; ');
      return (check.fine || 'Within range') + ': ' + fine.join('; ');
    }

    function update() {
      var live = !panel.hidden;
      tweaks.forEach(relabel);
      var collarEl = picked(collars), fitEl = picked(fits);
      var collar = collarEl ? collarEl.value : null;
      var fitKey = fitEl ? fitEl.getAttribute('data-crf-fit-fit') : null;
      var row = collar && fitKey ? findRow(collar, fitKey) : null;
      var vals = {}, limit = false, k;
      if (row) {
        for (k in row.v) vals[k] = num(row.v[k]);
        tweaks.forEach(function (sel) {
          var d = delta(sel), col = sel.getAttribute('data-crf-fit-tweak');
          if (atLimit(sel)) limit = true;
          if (d && vals[col] != null) vals[col] = vals[col] + d;
        });
      }
      if (shirt) {
        shirt.hidden = !row;
        shirt.querySelectorAll('[data-crf-fit-col]').forEach(function (cell) {
          var v = vals[cell.getAttribute('data-crf-fit-col')];
          cell.textContent = v == null ? '\u2013' : shown(v);
          var u = cell.nextElementSibling; if (u && u.hasAttribute('data-crf-fit-unit')) u.hidden = v == null;
        });
      }
      outs.forEach(function (o) {
        var v = vals[o.getAttribute('data-crf-fit-out')];
        o.value = v == null ? '' : fmt(v);
        o.disabled = !live || v == null;
      });
      var outUnit = panel.querySelector('[data-crf-fit-out-unit]');
      if (outUnit) outUnit.disabled = !live || !row;
      if (checkOut) {
        var text = row ? checkText(row, collar, vals, limit) : '';
        checkOut.value = text;
        checkOut.disabled = !live || !text;
      }
    }

    if (letter) letter.addEventListener('change', function () {
      var opt = letter.options[letter.selectedIndex];
      var c = opt && opt.getAttribute('data-collar');
      if (c) collars.forEach(function (r) { r.checked = r.value === c; });
      update();
    });
    collars.forEach(function (r) { r.addEventListener('change', function () { if (letter) letter.value = ''; update(); }); });
    fits.forEach(function (r) { r.addEventListener('change', update); });
    tweaks.forEach(function (s) { s.addEventListener('change', update); });
    [height, weight, notes].forEach(function (el) { if (el) el.addEventListener('input', update); });
    return { update: update };
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
